module.exports = __webpack_public_path__ + "resources/img/img_datahunt1_m.65b6a012886d4ad80d95599583786cab.png";